import { IToasterData } from './toaster.data';
import { handleActions } from 'redux-actions';
import { ActionsEnum, UpdateToasterData } from './toaster.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

// feature name
export const FEATURE_NAME = 'toaster-data';

// state interface
export interface IState {
  toasterData: IToasterData;
}

// initial states of store
export const initialState: IState = {
  toasterData: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.UPDATE_TOASTER_DATA]: function (
      state: IState,
      { payload }: UpdateToasterData
    ): IState {
      const { toasterData } = payload;

      return {
        ...state,
        toasterData,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getToasterData = createSelector(
  selectFeature,
  (state: IState) => state.toasterData
);
